/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TierType = "CORE" | "ENTERPRISE" | "FREE_FOREVER" | "LITE" | "PRO" | "TRIAL" | "%future added value";
export type ProfileProjectStatusUpdatesPage_viewer = {
    readonly projectOwner: boolean | null;
    readonly disableNotifications: boolean | null;
    readonly company: {
        readonly forecastDemo: boolean | null;
        readonly tier: TierType | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"ProfileProjectStatusUpdates_viewer" | "SettingsProfileSubNav_viewer">;
    readonly " $refType": "ProfileProjectStatusUpdatesPage_viewer";
};
export type ProfileProjectStatusUpdatesPage_viewer$data = ProfileProjectStatusUpdatesPage_viewer;
export type ProfileProjectStatusUpdatesPage_viewer$key = {
    readonly " $data"?: ProfileProjectStatusUpdatesPage_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ProfileProjectStatusUpdatesPage_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileProjectStatusUpdatesPage_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectOwner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "disableNotifications",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "forecastDemo",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tier",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileProjectStatusUpdates_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SettingsProfileSubNav_viewer"
    }
  ],
  "type": "Viewer"
};
(node as any).hash = 'c102696a5d8696a93f54e686974b0d9c';
export default node;
